/**
 * @module project/components/entry_details_component
 */
import React, { PropTypes } from 'react';
import classNames from 'classnames';

/**
 * Base details component for the single entry.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 *
 * @param {object} props - data required to render
 * @returns {node} - Base component that renders left drawer and
 *                   content elements.
 */
const SingleEntryDetails = (props) => {
  const { detailsState, leftDrawer, mainContent } = props;
  const leftDrawerVisible = (detailsState && detailsState.leftDrawerVisible) || false;
  const mainContentElements = (mainContent && mainContent.elements) || [];

  return (
    <div className="entry-wrapper">
      <section className="row expanded collapse">
        <div className={classNames('small-16 medium-6 large-4 column left-drawer',
          leftDrawer.classes,
          { hidden: !leftDrawerVisible })}
        >
          { leftDrawer.element }
        </div>
        <div className={classNames('small-16 medium-10 large-12 column entry-content',
          mainContent.classes,
          { 'full-width': !leftDrawerVisible })}
        >
          { mainContentElements.map(el => el) }
        </div>
      </section>
    </div>
  );
};

/**
 * PropTypes.
 *
 * @property {object} leftDrawer - object with classes and element to render in left drawer
 * @property {object} mainContent - object with classes and element to render as main content
 * @property {object} detailsState - object with entry details data
 */
SingleEntryDetails.propTypes = {
  leftDrawer: PropTypes.shape({
    classes: PropTypes.string,
    element: PropTypes.node,
  }),
  mainContent: PropTypes.shape({
    classes: PropTypes.string,
    elements: PropTypes.arrayOf(PropTypes.node),
  }),
  detailsState: PropTypes.object,
};

export default SingleEntryDetails;



// WEBPACK FOOTER //
// ./common/components/modal/single_entry_details.jsx